import PropTypes from 'prop-types';
import React from 'react';
import { hoursType } from '@types/index';

import { Navbar, NavbarBrand } from 'reactstrap';
import Logo from '@images/logo.svg';
import BurgerButton from '@components/Navigation/MobileNavigation/Elements/BurgerButton';
import DesktopNavigation from '@components/Navigation/Header/Elements/DesktopNavigation';
import MobileNavigation from '@components/Navigation/MobileNavigation';
import './index.scss';

// If we need to absolutely mimic current nav bar behavior, this looks promising...
// https://stackoverflow.com/questions/54164397/bootstrap-4-how-to-make-fixed-top-navbar-disappear-on-scroll

const Header = ({ data, hours, isHomePage }) => (
  <header
    className="header"
    aria-label="Main navigation"
    data-cy="app-nav"
  >
    <Navbar className="p-0" light>
      <NavbarBrand className="px-0 pb-0 pt-md-3" href="/">
        {isHomePage && <div className="logo-white-bg" id="brandShape" />}
        <Logo />
      </NavbarBrand>
      <DesktopNavigation data={data} hours={hours} />
      <BurgerButton />
    </Navbar>
    <MobileNavigation data={data} hours={hours} />
  </header>
);

const linkType = PropTypes.shape({
  title: PropTypes.string.isRequired,
  source: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
});

const itemsType = PropTypes.shape({
  title: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  links: PropTypes.arrayOf(linkType).isRequired,
});

Header.defaultProps = {
  hours: null,
  isHomePage: false,
};

Header.propTypes = {
  data: PropTypes.arrayOf(itemsType).isRequired,
  hours: hoursType,
  isHomePage: PropTypes.bool,
};

export default Header;
